// Unit converter for the inventory module.
//
// Families with a base unit: WEIGHT (base g), VOLUME (base ml), COUNT (base
// unit). Any pair inside a family converts both directions; across families
// (or custom units like case/pack) it returns null and the user types the
// factor by hand (they know what their case contains).

const FAMILY_OF = {
  // weight → grams
  g: ['weight', 1], kg: ['weight', 1000],
  oz: ['weight', 28.349523125], lb: ['weight', 453.59237],
  // volume → milliliters
  ml: ['volume', 1], l: ['volume', 1000],
  'fl oz': ['volume', 29.5735295625], gal: ['volume', 3785.411784],
  // count → units
  unit: ['count', 1], dozen: ['count', 12],
  // case/pack intentionally absent — user-defined content per supplier
};

/**
 * How many `to` units are in ONE `from` unit. null when not convertible.
 * convertFactor(1, 'lb', 'g') → 453.592 · convertFactor(1, 'gal', 'fl oz') → 128
 */
export function convertFactor(from, to) {
  if (from === to) return 1;
  const a = FAMILY_OF[from];
  const b = FAMILY_OF[to];
  if (!a || !b || a[0] !== b[0]) return null;
  return a[1] / b[1];
}

/** Convert a quantity between units (null when not convertible). */
export function convertUnits(qty, from, to) {
  const f = convertFactor(from, to);
  return f == null ? null : qty * f;
}
